import React, { useEffect } from "react";
import { about, aboutImg, aboutUsBgImage, blogSub, Maingraphimage } from "../../../../../images/index.js";
import EmpoweringGrowth from "../EmpoweringGrowth/EmpoweringGrowth";
import WhyChooseUs from "../WhyChoose/WhyChoose";
import OurJourney from "../OurJourney/OurJourney";
import OurTeam from "../OurTeam/OurTeam";
import Testimonial from "../Testimonials/Testimonial.jsx";
import TeamSection from "../OurTeam/TeamSection.js";
import Footer from "../Footer/Footer.js";
const AboutUs = () => {

  useEffect(() => {
    // ✅ Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return; // safeguard if not found

    // 🟢 Save old background before changing
    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    // 🟣 Apply About Us background image
    staticContainer.style.backgroundImage = `url(${aboutUsBgImage})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    staticContainer.style.backgroundAttachment = "fixed";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    // 🔴 Cleanup: restore old background when leaving AboutUs
    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);

  return (
    <>
      <div className="about-us"
       
      >
        <div className="about-hero-section">
          <div className="about-hero-section-inner">
            <div className="container-fluid">
              <div className=" px-4">
                <h2 className="hero-heading gradient-text text-center">
                  Turning Data Chaos{" "}
                </h2>
                <p className="hero-heading text-white text-center">
                  Into Growth Clarity With Gapalyze
                </p>
                <p className="hero-sub-text text-center">
                  We built Gapalyze to simplify decision-making. A single platform
                  where insights connect, teams align, and growth becomes
                  predictable.
                </p>
              </div>
            </div>
          </div>
          <div className="row about-upper-container mt-5">
            <div className="col-md-8 mt-5 w-full h-screen flex items-center justify-center bg-gray-100">
              <div className=" px-4">
                <h2 className="about-sub-heading text-white">
                  Amazon sellers struggle with one big challenge
                </h2>
                <p className="about-sub-content text-white">
                  They get endless reports - but no clarity. Teams waste time,
                  managers guess on ads, and owners feel blind about their
                  business health.
                </p>
                <p className="about-sub-content">
                  We built Gapalyze to simplify decision-making. We experienced
                  this problem first-hand. That’s why we created Gapalyze - to
                  take Amazon’s raw data and turn it into clear, actionable
                  insights.
                </p>
                <div>
                  <h2 className="about-sub-text-heading text-white">
                    Our mission
                  </h2>
                  <p className="about-sub-text">
                    Help every seller grow confidently on Amazon with simplicity,
                    transparency, and speed.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-5 w-full h-screen flex items-center justify-center bg-gray-100">
              <div className="about-hero-image-div">
                <img src={aboutImg} className="img-fluid"></img>
              </div>{" "}
            </div>
          </div>

          <div className="row mx-2 about-hero-image-container align-items-center">
            {/* LEFT IMAGE SIDE */}
            <div className="col-md-4 d-flex justify-content-center">
              <div className="about-hero-image-div">
                <img src={about} className="img-fluid" alt="About Gapalyze" />
              </div>
            </div>

            {/* RIGHT TEXT SIDE */}
            <div className="col-md-8 d-flex align-items-center">
              <div className="px-4 text-start w-100">
                <h2 className="about-sub-heading text-white">Our Story</h2>
                <p className="hero-sub-text text-white">
                  Empowering E-Commerce Growth Through Intelligent Insights.
                </p>
                <p className="about-sub-content">
                  We started Gapalyze with one mission: to bridge the gap between data and
                  decisions. E-commerce sellers were buried under reports, spreadsheets,
                  and guesswork — so we built a platform that brings everything together.
                  From ad spend to conversions, from traffic to revenue, Gapalyze gives
                  you clarity, speed, and control like never before.
                </p>
              </div>
            </div>
          </div>

          <WhyChooseUs />
          <OurJourney />
          <div className="row mx-2 about-hero-image-container">
            <div className="col-md-4 h-100">
              <div className="about-hero-image-div">
                <img src={blogSub} className="img-fluid"></img>
              </div>
            </div>
            <div className="col-md-8 w-full h-100 flex items-center justify-center">
              <div className=" px-4">
                <h2 className="about-sub-heading text-white">Our Promise</h2>
                <p className="hero-sub-text text-white">
                  We don’t just show you numbers — we make them meaningful.
                </p>
                <p className="about-sub-content">
                  Every insight on Gapalyze is designed to answer a real business
                  question, helping you focus on what drives growth, not just what
                  fills dashboards. Our team believes that the right data, in the
                  right hands, can transform performance and predict success.
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="promise-vision-section py-5 d-flex align-items-center justify-content-center text-center">
          <div className="blur-bg"></div> {/* Background glow layer */}
          <div className="position-relative">
            <div className="row justify-content-center">
              <div className="">
                <div className="promise-vision-card d-flex flex-column flex-md-row justify-content-between p-4 p-md-5">
                  {/* Our Promise */}
                  <div className="flex-fill px-md-4 py-3 border-left-div">
                    <h4 className="fw-bold text-primary mb-3">Our Promise</h4>
                    <p className="text-muted mb-0">
                      To empower e-commerce brands and sellers with deep,
                      actionable insights that solve real challenges, fuel smarter
                      decisions, and drive sustainable, measurable growth.
                    </p>
                  </div>
                  {/* Our Vision */}
                  <div className="flex-fill px-md-4 py-3 border-div">
                    <h4 className="fw-bold text-primary mb-3">Our Vision</h4>
                    <p className="text-muted mb-0">
                      To become the essential DNA of Amazon sales intelligence —
                      the global standard for transforming data into opportunity
                      and enabling every brand to reach its full potential.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="row mx-2 about-our-vlaue-container">
          <div className="col-md-8 w-full h-100 flex items-center justify-center">
            <div className="">
              <h2 className="about-sub-heading text-white">Our Values</h2>
              <ul className={`custom-list-container mt-4`}>
                <li
                  className={`custom-list-item text-start
              `}
                >
                  Clarity First: We simplify the complex.
                </li>
                <li
                  className={`custom-list-item text-start
              `}
                >
                  Truth in Data: Integrity and accuracy in every insight.
                </li>
                <li
                  className={`custom-list-item text-start
              `}
                >
                  Partnership Over Platform: We grow when you grow.
                </li>
                <li
                  className={`custom-list-item text-start
              `}
                >
                  Innovation With Purpose: Always evolving, never overwhelming.
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 h-100">
            <div className="about-hero-image-div">
              <img src={blogSub} className="img-fluid"></img>
            </div>
          </div>
          <OurJourney />
          <TeamSection />
        </div>

        {/* <OurTeam /> */}
        {/* <div className="stop-bugs-outer"> */}
          <Testimonial />
        {/* </div> */}
<Footer />
      </div>
    </>
  );
};
export default AboutUs;
